import { ReactElement } from 'react'
import { BackButton, Loader, PageWrapper } from '../../../../../components'
import { useHistory } from 'react-router-dom'
import { CardWrapper } from '../../subcomponents'
import { FlexWrapper, Column } from '../../../../../components'
import strings from '../../../../../locale/en'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../../redux/store'
import { Leave } from '../../../../../redux/manageLeave/type'
import { formatDate } from '../../../../../helpers'
import { resetSelectedLeave } from '../../../../../redux/manageLeave/action'

const ViewLeaveDetail = (): ReactElement => {
  const { isLoading, leave } = useSelector(
    (state: RootState) => ({
      isLoading: state.leave.isLoading,
      leave: state.leave.selectedLeave as Leave
    }),
    shallowEqual
  )

  const dispatch = useDispatch()
  const history = useHistory()
  const {
    leaveDetails: { type, fromDate, toDate, status, name, actionLabel, remarks }
  } = strings

  const {
    leaveType,
    fromDate: startDate,
    toDate: endDate,
    dayStatus,
    leaveName,
    action,
    remarks: description
  } = leave || {}

  return isLoading ? (
    <Loader />
  ) : (
    <PageWrapper id="container">
      <div>
        <BackButton
          handleBack={() => {
            dispatch(resetSelectedLeave())
            history.goBack()
          }}
        />
      </div>
      <FlexWrapper justifyContent="space-around">
        <CardWrapper>
          <Column keyName={type} value={leaveType} />
          <Column keyName={fromDate} value={formatDate(startDate)} />
          <Column keyName={toDate} value={formatDate(endDate)} />
          <Column keyName={status} value={dayStatus} />
        </CardWrapper>
        <CardWrapper>
          <Column keyName={name} value={leaveName} />
          <Column keyName={actionLabel} value={action} />
          <Column keyName={remarks} value={description} />
        </CardWrapper>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default ViewLeaveDetail
